"use client"

import { Component } from "react"
import axios from 'axios'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import API, { root_url, URL_PATH } from "../../services/API"
import Toast from "../../components/Toast"

class ListMenuScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        waiting: [],
        preparing: [],
        delivered: [],
        rejected: []
      },
      active: "pickup",
      version: 0,
      order_status: "all",
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
      rejectionModal: {
        open: false,
        orderId: null,
        reason: ""
      }
    };
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
    this.fetchKanbanData()
  }

  fetchKanbanData = async () => {
    try {
      const hotelId = this.props.selectedHotelId?.id
      const token = localStorage.getItem('token')

      const response = await axios.get(`${root_url}/api/hotelowner/order/kanbanview`, {
        params: { hotel_id: hotelId },
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })

      const result = response.data

      if (result.status === "success") {
        this.setState({
          data: {
            waiting: result.data.waiting || [],
            preparing: result.data.preparing || [],
            delivered: result.data.delivered || [],
            rejected: result.data.rejected || []
          }
        })
      } else {
        this.showToast(result.message || "Failed to fetch orders", "error")
      }
    } catch (error) {
      this.showToast("An error occurred while fetching orders", "error")
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") return
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  changeStatus = async (item, status, reason = "") => {
    try {
      const payload = {
        order_id: item.id,
        order_status: status,
      };

      if (status === "rejected" && reason) {
        payload.order_rejection_reason = reason;
      }

      const response = await API(this, "post", URL_PATH.updateOrderStatus, payload);

      if (response.status !== "success") {
        this.showToast(response.message, "error");
        return;
      }

      this.showToast("Order status updated successfully", "success");
      this.fetchKanbanData();
      this.handleCloseRejectionModal();
    } catch (error) {
      this.showToast("Failed to update order status", "error");
    }
  };

  handleOpenRejectionModal = (orderId) => {
    this.setState({
      rejectionModal: {
        open: true,
        orderId,
        reason: ""
      }
    });
  };

  handleCloseRejectionModal = () => {
    this.setState({
      rejectionModal: {
        open: false,
        orderId: null,
        reason: ""
      }
    });
  };

  handleReasonChange = (e) => {
    this.setState({
      rejectionModal: {
        ...this.state.rejectionModal,
        reason: e.target.value
      }
    });
  };

  handleDragEnd = (result) => {
    const { source, destination } = result

    // If dropped outside the list or in the same position
    if (!destination ||
      (source.droppableId === destination.droppableId &&
        source.index === destination.index)) {
      return
    }

    const sourceColumn = source.droppableId
    const destColumn = destination.droppableId
    const draggedItem = this.state.data[sourceColumn][source.index]

    // Define allowed status transitions
    const allowedTransitions = {
      waiting: ["preparing", "rejected"],  // Can only move to preparing or rejected
      preparing: ["delivered"],            // Can only move to delivered
      delivered: [],                       // Cannot be moved from delivered
      rejected: []                         // Cannot be moved from rejected
    }

    // Check if this transition is allowed
    if (!allowedTransitions[sourceColumn].includes(destColumn)) {
      return
    }

    // Map to actual status values
    const statusMapping = {
      waiting: "completed",
      preparing: "kot",
      delivered: "served",
      rejected: "rejected"
    }

    // First update the status on server
    this.changeStatus(draggedItem, statusMapping[destColumn])

    // Then update local state if server update was successful
    const newData = { ...this.state.data }
    newData[sourceColumn] = [...this.state.data[sourceColumn]]
    newData[sourceColumn].splice(source.index, 1)
    newData[destColumn] = [...this.state.data[destColumn]]
    newData[destColumn].splice(destination.index, 0, draggedItem)

    this.setState({ data: newData })
  }

  renderOrderCard = (order, columnId, index) => {
    console.log("Order data in pickup", order)
    const statusColors = {
      waiting: { bg: "#FEE2E2", text: "#B91C1C", button: "#BB0A21" },
      preparing: { bg: "#FEF3C7", text: "#92400E", button: "#FFC857" },
      delivered: { bg: "#DCFCE7", text: "#166534", button: "#00A651" },
      rejected: { bg: "#E5E7EB", text: "#374151", button: "#6B7280" }
    }

    return (
      <Draggable key={order.id.toString()} draggableId={order.id.toString()} index={index}>
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...provided.draggableProps.style,
              marginBottom: "16px",
              padding: "16px",
              backgroundColor: "#02111B",
              borderRadius: "12px",
              borderLeft: `4px solid ${statusColors[columnId].button}`,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
              <span style={{ fontWeight: "600", color: "white" }}>Order {order.id}</span>
              <span style={{ fontSize: "12px", color: "white" }}>
                {order.order_date_time}
              </span>
            </div>

          <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
              <div style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: statusColors[columnId].bg,
                color: statusColors[columnId].text,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "8px",
                fontWeight: "bold",
                fontSize: "14px"
              }}>
                {order.user?.name?.charAt(0)?.toUpperCase() || '?'}
              </div>
              <div>
              <div style={{ fontWeight: "500", color: "white" }}>
                {order.user?.name?.split(" ")[0] || 'Customer'}
              </div>
              
              {order.user?.mobile && (
                <div style={{ fontSize: "12px", color: "white" }}>
                  {order.user.mobile}
                </div>
              )}
              
              {order.order_rejection_reason && (
                <div style={{ fontSize: "12px", color: "white" }}>
                  Rejection Reason: {order.order_rejection_reason}
                </div>
              )}
            </div>
            </div>

            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "12px",
              paddingTop: "12px",
              borderTop: "1px solid #6B7280"
            }}>
              <div style={{ fontWeight: "bold", color: "white" }}>
                ₹{Number.parseFloat(order.final_total).toLocaleString()}
              </div>

              <div style={{ display: "flex", gap: "8px" }}>
                <button
onClick={() => this.props.history.push(routes.admin.orders.show(this.props.hotels[0].hotel_slug, order.order_type_slug, order.id))}
style={{
                    padding: "6px 12px",
                    backgroundColor: "#0D6EFD",
                    color: "white",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "700"
                  }}
                >
                  View
                </button>

                {columnId === "waiting" && (
                  <>
                    <button
                      onClick={() => this.changeStatus(order, "kot")}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: "#FFC857",
                        color: "black",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "700"
                      }}
                    >
                      Send to KOT
                    </button>
                    <button
                      onClick={() => this.handleOpenRejectionModal(order.id)}
                      style={{
                        padding: "6px 12px",
                        backgroundColor: "#BB0A21",
                        color: "white",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "700"
                      }}
                    >
                      Reject
                    </button>
                  </>
                )}

                {columnId === "preparing" && (
                  <button
                    onClick={() => this.changeStatus(order, "served")}
                    style={{
                      padding: "6px 12px",
                      backgroundColor: "#00A651",
                      color: "white",
                      borderRadius: "6px",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "700"
                    }}
                  >
                    Ready
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </Draggable>
    )
  }

  render() {
    const columnTitles = {
      waiting: "Pending",
      preparing: "In Process",
      delivered: "Completed",
      rejected: "Rejected"
    }

    return (
      <div style={{
        backgroundColor: "#02111B",
        minHeight: "100vh",
        width: "100%",
        padding: "16px",
        boxSizing: "border-box"
      }}>
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />

        <DragDropContext onDragEnd={this.handleDragEnd}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "16px",
            width: "100%",
            boxSizing: "border-box"
          }}>
            {Object.keys(this.state.data).map((columnId) => {
              const columnData = this.state.data[columnId]
              const columnCount = columnData.length

              const columnStyles = {
                waiting: { headerBg: "#041A29", countBg: "#B91C1C", countColor: "white" },
                preparing: { headerBg: "#041A29", countBg: "#FFC857", countColor: "black" },
                delivered: { headerBg: "#041A29", countBg: "#00A651", countColor: "black" },
                rejected: { headerBg: "#041A29", countBg: "#6B7280", countColor: "black" }
              }



              return (
                <div key={columnId} style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  backgroundColor: "#041A29",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  height: "fit-content",
                  maxHeight: "calc(100vh - 32px)",
                  display: "flex",
                  flexDirection: "column"
                }}>
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px",
                    backgroundColor: columnStyles[columnId].headerBg,
                    borderBottom: "1px solid #6B7280",
                    flexShrink: 0
                  }}>
                    <div style={{ fontWeight: "600", color: "white" }}>
                      {columnTitles[columnId]}
                    </div>
                    <span style={{
                      backgroundColor: columnStyles[columnId].countBg,
                      color: columnStyles[columnId].countColor,
                      borderRadius: "9999px",
                      padding: "4px 10px",
                      fontSize: "12px",
                      fontWeight: "600"
                    }}>
                      {columnCount}
                    </span>
                  </div>

                  <Droppable droppableId={columnId}>
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={{
                          padding: "16px",
                          overflowY: "auto",
                          scrollbarWidth: "thin",
                          scrollbarColor: "#6B7280 transparent",
                          flex: 1
                        }}
                      >
                        {columnData.map((order, index) =>
                          this.renderOrderCard(order, columnId, index)
                        )}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </div>
              )
            })}
          </div>
        </DragDropContext>
        {/* Rejection Reason Modal */}
{this.state.rejectionModal.open && (
  <div style={{
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
  }}>
    <div style={{
      backgroundColor: "#02111B",
      padding: "24px",
      borderRadius: "12px",
      width: "400px",
      maxWidth: "90%",
    }}>
     
      <textarea
        value={this.state.rejectionModal.reason}
        onChange={this.handleReasonChange}
        placeholder="Enter rejection reason..."
        style={{
          width: "100%",
          minHeight: "100px",
          padding: "12px",
          borderRadius: "6px",
          backgroundColor: "#041A29",
         
          color: "white",
          // border: "1px solid #6B7280",
          marginBottom: "16px"
        }}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
        <button
          onClick={this.handleCloseRejectionModal}
          style={{
            padding: "8px 16px",
            backgroundColor: "#BB0A21",
            fontWeight: "700",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer"
          }}
        >
          Cancel
        </button>
        <button
          onClick={() => {
            const order = this.state.data.waiting.find(
              o => o.id === this.state.rejectionModal.orderId
            );
            if (order) {
              this.changeStatus(
                order, 
                "rejected", 
                this.state.rejectionModal.reason
              );
            }
          }}
          style={{
            padding: "8px 16px",
            backgroundColor: "#FFC857",
            color: "black",
            border: "none",
            fontWeight: "700",
            borderRadius: "6px",
            cursor: "pointer"
          }}
          disabled={!this.state.rejectionModal.reason.trim()}
        >
          Confirm Reject
        </button>
      </div>
    </div>
  </div>
)}
      </div>
    )
  }
}

export default redux(ListMenuScreen)